/**
 * Breakpoint name type
 */
export type BreakpointName = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/**
 * Breakpoint configuration
 */
interface Breakpoint {
  name: BreakpointName;
  min: number;
  max: number;
}

const breakPoints: Breakpoint[] = [
  { name: 'xs', min: 0, max: 599 },
  { name: 'sm', min: 600, max: 959 },
  { name: 'md', min: 960, max: 1279 },
  { name: 'lg', min: 1280, max: 1919 },
  { name: 'xl', min: 1920, max: Infinity },
];

const windowInnerWidth = typeof window !== 'undefined' ? window.innerWidth : 1280;

/**
 * Converts a width value to its corresponding breakpoint name
 *
 * @param width - The width in pixels (defaults to window.innerWidth)
 * @returns The breakpoint name for the given width
 */
const widthToBreakPoint = (width: number = windowInnerWidth): BreakpointName | undefined => {
  let breakPointName: BreakpointName | undefined;
  breakPoints.forEach((item) => {
    if (width < item.max && width >= item.min) {
      breakPointName = item.name;
    }
  });
  return breakPointName;
};

export default widthToBreakPoint;
